import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight, faEllipsis } from "@fortawesome/free-solid-svg-icons";
import { classNames } from "@ct-react/core";
import { SearchPaginationInfo, SearchPaginationLink } from "../../models/search-param";
import "./search-result-pagination.scss"
import { SearchPagination } from "../../models/search";

type SearchResultPaginationProps = {
  data: SearchPaginationInfo;
  onChange?: (value: SearchPagination) => void;
}

const SearchResultPagination = ({ data, onChange = () => void 0 }: SearchResultPaginationProps) => {

  return (
    <div className="articles-pagination">
      <div className="pagination-container">

        {data.pageCount > 1 &&
          <button disabled={!data.hasPreviousPage}
                  className="pagination"
                  onClick={() => onChange({ direction: "before", cursor: data.previousPageCursor })}
                  type="button">
            <FontAwesomeIcon icon={faAngleLeft} />
          </button>
        }

        <button disabled={data.currentPage === 1}
                className={classNames("pagination",{currentPage: data.currentPage === 1})}
                onClick={()=> onChange({ direction: "after" })}
                type="button">1</button>

        {(data.pageCount > 3 && data.currentPage > 3) &&
          <FontAwesomeIcon icon={faEllipsis} />
        }

        {!!data.linkPageCursors && data.linkPageCursors.map((link: SearchPaginationLink, index: number) => {
          return(
            <button key={index}
                    className={classNames("pagination",{currentPage: link.page === data.currentPage})}
                    onClick={() => onChange({ direction: "after", cursor: link.cursor })}
                    type="button">
              {link.page}
            </button>);
        })}

        {(data.pageCount > 3 && data.currentPage < data.pageCount - 4) &&
          <FontAwesomeIcon icon={faEllipsis} />
        }

        {data.pageCount > 1 &&
          <button disabled={data.currentPage === data.pageSize}
                  className={classNames("pagination",{currentPage: data.pageCount === data.currentPage})}
                  onClick={()=> onChange({ direction: "after", cursor: data.lastPageCursor })}
                  type="button">{data.pageCount}</button>
        }

        {data.pageCount > 1 &&
          <button disabled={!data.hasNextPage}
                  className="pagination"
                  onClick={() => onChange({ direction: "after", cursor: data.nextPageCursor })}
                  type="button">
            <FontAwesomeIcon icon={faAngleRight} />
          </button>
        }

      </div>
    </div>);

};

export default SearchResultPagination;
